import { Directive, OnInit, HostListener, Input, AfterViewInit, OnChanges } from '@angular/core';
import * as fromHelpStore from '@appStore/help';
import { Router } from '@angular/router';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { Store } from '@ngrx/store';

@Directive({
    selector: 'mat-tab-group[appSelectedTab]',
    standalone: false
})
export class SelectedTabDirective implements OnInit, OnChanges, AfterViewInit {
  @Input() appSelectedTabIndex: number;

  currentUrl: string;
  selectedIndex: number;

  constructor(
    private matTabGroupComponent: MatTabGroup,
    private router: Router,
    private store: Store<fromHelpStore.State>
  ) {}

  ngOnInit() {}

  ngOnChanges() {}

  ngAfterViewInit() {
    // this.selectedIndex = this.matTabGroupComponent.selectedIndex;
    // const selectedTab = this.matTabGroupComponent._tabs.filter(t => t.position === this.selectedIndex);

    this.selectedIndex = this.matTabGroupComponent.selectedIndex;
    // offSet, if tab no 3 i selected (gets position 0), first tab has position -2, strange behaviour
    let firstPosition = this.matTabGroupComponent._tabs.first.position; 
    let adjustedSelectedIndex = this.selectedIndex + firstPosition;
    const selectedTab = this.matTabGroupComponent._tabs.filter(t => t.position === adjustedSelectedIndex);
    if (selectedTab && selectedTab.length > 0) {
      const label = selectedTab[0].textLabel;
      this.store.dispatch(new fromHelpStore.SelectTab(label));
    }
  }

  @HostListener('selectedTabChange', ['$event'])
  public selectedTabChange(event: MatTabChangeEvent) {
    const label = event.tab.textLabel;
    this.store.dispatch(new fromHelpStore.SelectTab(label));
  }
}
